module.exports = __webpack_public_path__ + "static/media/hoasen_home_logo.cc4f9a92.svg";